import "./AddUser.css";
import { useNavigate } from "react-router-dom";
import boxbg from "../../assets/user_photo.svg";
import { ReactSession } from "react-client-session";

const AddBox = () => {

  const navigate = useNavigate()

  const username = ReactSession.get("username");

  const addClaim = () => {
    navigate('/add-claim')
  }

  return (
    <div className="supervisor-addbox-flex-container">
      <section className="supervisor-addbox-sec-1">
        <div>
          <p className="supervisor-addbox-sec-1-head">Welcome back,</p>
          <a className="supervisor-addbox-sec-1-user_name">
            {username}
          </a>
        </div>

        <div className="supervisor-addbox-sec-1-btn-container">
          {/* <button
            onClick={registerUserHandler}
            className="supervisor-addbox-sec-1-btn"
          >
            Add new 
            <br />
            Operator +
          </button> */}
          {/* <div className="supervisor-addbox-sec-1-btn-container"> */}
            <button onClick={addClaim} className="addbox-sec-1-btn">
              ADD NEW CLAIM
            </button>
          {/* </div> */}
        </div>
      </section>

      <section className="supervisor-addbox-sec-2">
        <img className="supervisor-addbox-box-bg" src={boxbg} alt="asd" />
      </section>
    </div>
  );
};

export default AddBox;
